import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Discord.svg?component
var Discord_exports = /* @__PURE__ */ __exportAll({
	default: () => Discord_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M10.145 5.108a.584.584 0 0 1-.657-.37l-.24-.705a.51.51 0 0 0-.496-.35c-1.835.065-3.434.577-4.13.834a1.2 1.2 0 0 0-.6.474c-.75 1.142-3.085 5.242-3.02 11.944.003.4.169.78.485 1.025.716.556 2.259 1.576 4.702 2.314.358.108.75.004.962-.304.316-.462.597-1.04.796-1.494a.56.56 0 0 1 .669-.31c.87.248 1.993.439 3.39.439 1.393 0 2.512-.19 3.379-.437a.56.56 0 0 1 .669.31c.199.454.48 1.03.795 1.492.211.308.604.412.962.304 2.443-.738 3.986-1.758 4.703-2.314.315-.245.48-.626.485-1.025.063-6.652-2.236-10.74-3.003-11.917a1.25 1.25 0 0 0-.654-.5c-.75-.256-2.428-.763-4.094-.833a.505.505 0 0 0-.496.348l-.239.703a.586.586 0 0 1-.66.37 10.5 10.5 0 0 0-1.846-.15c-.827 0-1.461.08-1.862.152" }, null, -1), createElementVNode("path", { d: "M10 12.553c0 1.38-1.008 2.5-2.25 2.5-1.243 0-2.25-1.12-2.25-2.5 0-1.381 1.007-2.5 2.25-2.5 1.242 0 2.25 1.119 2.25 2.5m4 0c0 1.38 1.007 2.5 2.25 2.5 1.242 0 2.25-1.12 2.25-2.5 0-1.381-1.008-2.5-2.25-2.5-1.243 0-2.25 1.119-2.25 2.5" }, null, -1)])]);
}
var Discord_default = { render: render$1 };
//#endregion
export { Discord_exports, Discord_default as default, render$1 as render };

//# sourceMappingURL=Discord.svg.virtual.js.map